export const companyProfileText = [
    { key: 'phone', label: 'Phone' },
    { key: 'emailAddress', label: 'Email' },
    { key: 'address', label: 'Address' }
];
